module.exports = __webpack_public_path__ + "static/media/connected_world.73ac2c2d.svg";